





































































































































































import ExpandFullscreen from "@/components/Common/Chart/ExpandFullscreen.vue";
import { useGameModal } from "@/stores/common/game/gameModalStore";
import { storeToRefs } from "pinia";
import { computed } from "@vue/composition-api";
import { i18n } from "@core/plugins";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const locale = computed(() => i18n.locale);
  const gameModalStore = useGameModal();
  const {
    isActive,
    score,
    chance,
    bonus
  } = storeToRefs(gameModalStore);
  function close() {
    isActive.value = false;
  }
  return {
    locale,
    isActive,
    score,
    chance,
    bonus,
    close
  };
};
__sfc_main.components = Object.assign({
  ExpandFullscreen
}, __sfc_main.components);
export default __sfc_main;
